import React, { useRef } from "react";
import { Helmet } from 'react-helmet-async'; // ★これと
import { device } from '../MainContents/Style/StyleDevice';
import UniversityTable from "./UniversityTable";
import UniversityTable2025 from "./UniversityTable2026";
import SuccessList from "./SuccessList";
import ImgSuccessList from '../../img/successList.jpg';
import styled from "styled-components";
import FlashReport from "./FlashReport";
const DivTop = styled.div`
    margin: auto;
    margin-top: 170px;
    width: 90%;
  @media ${device.mobile} {
    margin-top: 80px;
    width: 95%;
  }
`;
const Iframe = styled.iframe`
    width: 100%;
    height :400px;
    overflow: auto; /* スクロールバーを非表示 */
`;

const schoolDataKokouritu = [
    { name: "京都大", count: 1 },
    { name: "神戸大", count: 2 },
    { name: "島根大", count: 2 },
    { name: "広島大(医)", count: 1 },
    { name: "香川大", count: 1 },
    { name: "愛媛大", count: 1 },
    { name: "高知大", count: 6 },
    { name: "東京都立大", count: 1 },
    { name: "静岡文化芸術大", count: 1 },
    { name: "大阪公立大", count: 1 },
    { name: "広島市立大", count: 1 },
    { name: "高知県立大", count: 1 },
];

const schoolDataKokourituKouki = [
    { name: "電気通信大", count: 1 },
    { name: "大阪公立大", count: 1 },
    { name: "高知大", count: 1 },
    { name: "高知工科大", count: 1 },
];

function Success() {

    return (
        <DivTop>
            {/* ★ここからHelmetの記述を追加します */}
            <Helmet>
                <title>土佐塾予備校　高知での実績No.1予備校</title> {/* ←ここに希望するタイトルを設定 */}
                <meta name="description" content="JR高知駅から徒歩5分と最高の交通アクセス！！ 本校は県内唯一の学校法人の予備校です。 公共交通機関の学割制度を利用できるので、経済的に負担も大幅に軽減できます。" />
                {/* 必要であれば、OGPタグなどもここに追加できます */}
                {/* <meta property="og:title" content="TOSAYOBI高等学院" /> */}
                {/* <meta property="og:description" content="高知の通信制高校です。" /> */}
                {/* <meta property="og:url" content="http://localhost:3000/TosayobiHighSchool" /> */}
                {/* <meta property="og:image" content="ここにOGP画像のURL" /> */}
            </Helmet>
            {/* 見出し */}
            <h1 className="mb-6 text-3xl font-bold text-black border-b-4 border-red-500 pb-2 inline-block shadow-sm">
                2026年度入試　土佐塾予備校　合格実績
            </h1>
            <UniversityTable2025 />
            {/* <FlashReport 
                titleSokuhou="国公立大中期・後期合格" 
                postingSokuhou="2025年国公立大中期・後期日程合格(3/23判明分)"
                schoolData={schoolDataKokourituKouki} 
            />

            <FlashReport 
                titleSokuhou="2025年国公立大学合格速報" 
                postingSokuhou="2025年国公立大合格速報(3/10判明分)"
                schoolData={schoolDataKokouritu} 
            /> */}

            <div className="mt-10 mb-0">
                <div className="text-center bg-red-100 rounded-md p-3 shadow-md mb-6 relative">
                    {/* 桜の装飾（オプション） */}
                    <div className="absolute left-2 top-2 opacity-30">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="pink">
                            <path d="M12 2c1.1 0 2 .9 2 2 0 .45-.15.86-.4 1.2.58-.12 1.22-.2 1.88-.2 2.21 0 4 1.79 4 4 0 .99-.37 1.9-.98 2.6.2-.03.4-.06.6-.06 1.1 0 2 .9 2 2 0 1.24-.95 2.25-2.17 2.38 0 .07.01.14.01.22 0 2.21-1.79 4-4 4-1.06 0-2.03-.42-2.74-1.1-.71.68-1.68 1.1-2.74 1.1-2.21 0-4-1.79-4-4 0-.08.01-.15.01-.22C4.95 16.25 4 15.24 4 14c0-1.1.9-2 2-2 .2 0 .4.03.6.06-.61-.7-.98-1.61-.98-2.6 0-2.21 1.79-4 4-4 .66 0 1.3.08 1.88.2A1.99 1.99 0 0112 2z" />
                        </svg>
                    </div>

                    {/* 見出し */}
                    <h1 className="text-3xl font-bold text-black border-b-4 border-red-500 pb-2 inline-block shadow-sm">
                        2011～2025 合格実績
                    </h1>
                </div>
                <UniversityTable />
            </div>
            {/* <div class="table__container js-scrollable">
            <Iframe src={'/Success/'}></Iframe>
        </div> */}
            <hr />
            <h3 className="mt-12 text-2xl text-pink-400 font-bold w-3/4 mx-auto"><span className="pr-3 align-middle"><span class="material-symbols-outlined">
                comment
            </span></span>2026年春　合格体験記</h3>

            <hr className="w-3/4 mx-auto" />

            {/* 2026年 STR */}
            <>
                <SuccessList
                    college={'京都大学'}
                    college_faculty={'理学部'}
                    school={'土佐高校'}
                    name={'Ｅ・Ａ'}
                    comment={'国立大入試では総合力が試されます。自分のようにミスの多い人は、一科目に特化して戦うのは危険です。そのため私は、この一年間弱点の強化に努めました。それには基礎固めが欠かせません。TOSAYOBIはそれに適した場所だと思います。生徒一人ひとりへの先生方のサポートが充実していました。私は授業や添削指導を受けて特に弱点の物理や国語を伸ばしました。新たにTOSAYOBIに入る皆さんには、積極的に先生方を頼り、この一年を価値あるものにできるよう頑張って欲しいです。'}
                />

                <SuccessList
                    college={'北海道大学'}
                    college_faculty={'文学部'}
                    school={'小津高校'}
                    name={'Ｋ・Ｒ'}
                    comment={'浪人する上で最も大事なことは自分を律することです。大学に進学した同級生と自分を比べて孤独に感じたり、浪人中にはたくさんつらいときがあると思います。そんな時でも、浪人すると決意した自分を曲げずに着実に歩み続けましょう。たとえ途中で立ち止まったとしても、また歩き出せば大丈夫です。浪人生活中で得られるものは学力だけではないはずです。後悔の無いように、そして来年の春を笑顔で迎えられるように、周囲の人々への感謝を忘れずに一年間頑張ってください。'}
                />

                <SuccessList
                    college={'岡山大学'}
                    college_faculty={'教育学部'}
                    school={'学芸高校'}
                    name={'Ｋ・Ｋ'}
                    comment={'私は、浪人生活において大切なことは現役の時の自分を反省することだと思います。自分なりに努力をしていたと思いますので、自身を否定的に見ることは大変つらいことです。しかし、反省がなければ同じ失敗を繰り返すことになります。自己分析が難しいときはTOSAYOBIの先生方の力を借りましょう。たった一人で孤独に戦うよりも，予備校という環境を最大限に活かし、今のくやし涙を一年後にはうれし涙に変えることができるように頑張りましょう。'}
                />

                <SuccessList
                    college={'高知大学'}
                    college_faculty={'医学部医学科'}
                    school={'土佐高校'}
                    name={'Ｎ・Ｓ'}
                    comment={'私は現役生だった頃、共通テスト対策と二次対策のことばかり考え,基礎の立ち返ることはしませんでした。TOSAYOBIでは基礎から実戦的な演習まで幅広く学ぶことができました。特に記述式の答案を添削指導していただく機会が多かったことが本当にありがたかったです。できているつもりになっていることが一番怖いということを実感しました。先生方に積極的に質問をして自分の癖や弱点を克服し、最後まで諦めず第一志望に向かって頑張ってください。'}
                />

                <SuccessList
                    college={'高知大学'}
                    college_faculty={'医学部医学科'}
                    school={'土佐高校'}
                    name={'Ｎ・Ｓ'}
                    comment={'私は現役の時，ほとんどの模試でE判定でした。そのため、浪人をしてからは、閉館時間までほぼ毎日自習室に残って勉強していました。その中で基礎の大切さを実感しました。TOSAYOBIの添削指導は自分の弱点や理解したつもりになっている箇所を客観的に知るいい機会になったと思います。共通テストでは思っていたほど点数がとれませんでしたが、二次試験ではこの1年自分がやってきたことを信じ、実力を出し切ることができました。浪人生活は苦しいこともありますが、自分の糧になるように頑張ってください。'}
                />

                <SuccessList
                    college={'高知大学'}
                    college_faculty={'人文社会科学部'}
                    school={'高卒認定'}
                    name={'Ｙ・Ｓ'}
                    comment={'私は現役時代に頼る人もなく、半分独学で大学を受験したのですが、結果は惨敗でした。TOSAYOBIに入学仕立ての頃、元々との気質もあり、なかなか先生に質問や相談ができなかったのですが、このままではダメだと勇気を出して先生の元に行きました。TOSAYOBIの先生方は親身になって話を聞いてくださいました。そのおかげで気兼ねなく質問や相談ができるようになり、自分一人で受験していた時とは比較にならないくらい着実に成長することができ、無事に第一志望に合格することができました。このすてきな学舎で皆さんが来年合格できることを心から願っています。'}
                />

                <SuccessList
                    college={'高知大学'}
                    college_faculty={'人文社会科学部'}
                    school={'追手前高校吾北分校'}
                    name={'Ｓ・Ｔ'}
                    comment={'第一志望合格を手にし、今は達成感でいっぱいです。TOSAYOBIでの浪人生活が私に一番大切にしていたことは、「基礎の徹底」と「即日の復習」です。授業ではTOSAYOBIの先生方の解説を自分なりに咀嚼することを意識し、その日のうちに自力で解き直すサイクルを継続しました。この積み重ねが共通テスト本番での得点大幅アップに直結したと確信しています。地道な努力の継続こそが、最後に自分を支える武器になると思います。皆さんの夢の実現に向けてTOSAYOBIで自分を磨き続けてください。'}
                />

                <SuccessList
                    college={'高知大学'}
                    college_faculty={'人文社会科学部'}
                    school={'追手前高校'}
                    name={'Ｎ・Ｙ'}
                    comment={'私は他の人と比べても、決して勉強ができる方ではなかったと思います。しかし、TOSAYOBIに入学し、自分には何が足りないかをしっかりと考え真剣に向き合ったからこそ第一志望の合格を掴むことができました。また、前期試験直前は不安で勉強にも身が入らなかったこともありましたが、クラス主任の先生から送られてきたLINEのメッセージにとても励まされました。受験は自分自身との勝負の場でもあります。自分の成長を日々感じながら、第一志望合格を目指して頑張ってください。'}
                />

                <SuccessList
                    college={'高知大学'}
                    college_faculty={'教育学部'}
                    school={'土佐塾高校'}
                    name={'Ｅ・Ｈ'}
                    comment={'私はTOSAYOBIに通うことで、苦手教科の勉強はもちろん、自分の将来をきちんと考えることができました。苦手教科の勉強は後回しにしてしまいがちですが、先生方による添削指導のおかげでしっかりと向き合うことができました。なにより大きかったのは、一年間の授業を通して二次試験で必要となる小論文の指導をしていただけたことです。現役の頃よりも書く力を養うことができ、本番も自信を持って挑むことができました。努力が報われた今、一年間頑張ってきて良かったと思います。'}
                />

                <SuccessList
                    college={'同志社女子大学'}
                    college_faculty={'生活科学部'}
                    school={'土佐塾高校'}
                    name={'Ｎ・Ｕ'}
                    comment={'私は現役時代、進学先の大学を一般入試で挑戦しましたが、合格することはできませんでした。志望校に行きたいと言いながら、そのための努力が全く比例していなかったと思います。浪人が決まってからは苦手科目の克服や、得意科目の強化をTOSAYOBIの先生方、家族、友だちに支えてもらいながら行いました。絶対にこの大学に行きたいという気持ちを強くもって浪人生活を過ごせたのは、手厚く指導してくださったTOSAYOBIの先生方のおかげだと思っています。ありがとうございました。'}
                />
            </>
            {/* 2026年 END */}
        </DivTop>
    );
}

export default Success;
